import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/Locale';

const localeReducer = handleActions({
    [Actions.changeLanguageActions]: (state, action) => ({
        ...state,
        current: action.payload,
    }),
}, {
    current: 'ja',
});

const changeLangOtherReducer = handleActions({
    [Actions.changeLanguageOtherActions]: (state, action) => ({
        ...state,
        current: action.payload,
    }),
    [Actions.changeLanguageOtherInit]: (state) => ({
        ...state,
        current: '',
    }),
}, {
    current: '',
});

const changeLanguageReducer = handleActions({
    [Actions.updateLanguageRequest]: () => ({
        isFetching: true,
        lang: '',
        errors: {},
    }),
    [Actions.updateLanguageReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        lang: action.payload,
        errors: {},
    }),
    [Actions.updateLanguageFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        lang: '',
        errors: action.payload.errors,
    }),
    [Actions.updateLanguageInit]: () => ({
        isFetching: false,
        lang: '',
        errors: {},
    }),
}, {
    isFetching: false,
    lang: '',
    errors: {},
});

export default combineReducers({
    lang: localeReducer,
    changeLanguage: changeLanguageReducer,
    changLangOther: changeLangOtherReducer,
});
